export default __webpack_public_path__ + "static/media/Eco2.51fcb4c5.png";